import objectHelper from "@/classes/helpers/objectHelper";

export default class UserInformations {
  salaireBrut = 3000;
  primes = 150;
  nombreEnfantsMoins27Ans = 2;
  isContractuel = false;

  constructor(data) {
    if (data) {
      objectHelper.assignOnlyExisting(this, data);
    }
  }

  getRemunerationBruteMensuelleTotale() {
    return this.salaireBrut + this.primes;
  }
}
